// extracted by mini-css-extract-plugin
module.exports = {"text":"DropDown_text__20lBE"};